import de from './de'
import en from './en'
import bg from './bg'
import tr from './tr'

export const content = { de, en, bg, tr }
